import { css, unsafeCSS } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    section.add-to-cart {
      display: flex;
      flex-direction: column;
    }

    .content-wrapper-header {
      height: calc(24rem / var(--default-rem-px-count));
      padding-bottom: calc(8rem / var(--default-rem-px-count));
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .close-modal {
      height: calc(12rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .close-modal img {
      height: calc(24rem / var(--default-rem-px-count));
    }

    .added-to-cart {
      font-weight: 500;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .content-wrapper > div {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
    }

    .image-wrapper {
      display: flex;
    }

    .image-wrapper img {
      max-width: 100%;
      max-height: 40vh;
      margin: auto;
    }

    .details-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .price {
      padding-top: calc(24rem / var(--default-rem-px-count));
      /* The price is an h3 for structure but reads as a small label, so
         it sits below the bare h3 heading default. */
      font-size: calc(10rem / var(--default-rem-px-count));
      line-height: calc(16rem / var(--default-rem-px-count));
    }

    .sample-limit {
      margin-top: auto;
    }

    .contact-rep,
    .contact-rep:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    .ctas-wrapper {
      display: flex;
      flex-direction: row;
      padding-top: calc(40rem / var(--default-rem-px-count));
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .ctas-wrapper > cta-button {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
      max-width: calc(50% - calc(7rem / var(--default-rem-px-count)));
    }

    .login-content {
      display: flex;
      flex-direction: column;
      padding-bottom: calc(10rem / var(--default-rem-px-count));
    }

    .external-login-form-container {
      padding-top: calc(24rem / var(--default-rem-px-count));
    }

    .external-login-form-container slot {
      display: block;
    }

    .external-login-form-container ::slotted(external-login-form) {
      display: block;
    }

    .description {
      font-size: calc(14rem / var(--default-rem-px-count));
      letter-spacing: -0.24px;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      /* The modal deliberately sits a step off the shared scale: a 32px
         heading and a 16/20 price label. */
      h2 {
        font-size: calc(32rem / var(--default-rem-px-count));
      }

      .price {
        font-size: calc(16rem / var(--default-rem-px-count));
        line-height: calc(20rem / var(--default-rem-px-count));
        letter-spacing: normal;
      }

      .content-wrapper {
        flex-direction: row;
      }

      .image-wrapper img {
        width: 100%;
        max-width: unset;
        max-height: unset;
        margin: unset;
      }
    }
  `,
];

const EXTERNAL_LOGIN_FORM_SCOPE =
  'add-to-cart-modal external-login-form.add-to-cart-modal-external-login-form';

export const externalLoginFormOverrides = `
  ${EXTERNAL_LOGIN_FORM_SCOPE} {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .client-hub-login-wrapper {
    font-size: 14px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .content,
  ${EXTERNAL_LOGIN_FORM_SCOPE} form,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .text-form-field,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .input-icon-wrapper,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .button-container,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .account-actions,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .login-links,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .login-links a,
  ${EXTERNAL_LOGIN_FORM_SCOPE} input.cf-input,
  ${EXTERNAL_LOGIN_FORM_SCOPE} .log-in {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .input-form {
    gap: 20px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .input-icon-wrapper {
    display: flex;
    align-items: center;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} input.cf-input {
    height: 40px;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 20px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .input-title {
    margin-bottom: 6px;
    font-size: 12px;
    line-height: 16px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .remember-me-wrapper {
    margin: 24px 0 0 2px;
    font-size: 14px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .account-actions {
    margin-top: 20px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .log-in {
    min-height: 40px;
    margin-top: 24px;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} button.input-icon.password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    flex: 0 0 auto;
    min-height: 40px;
    top: auto;
  }

  ${EXTERNAL_LOGIN_FORM_SCOPE} .input-icon mat-icon {
    display: block;
    line-height: 1;
  }

  @media (max-width: 599px) {
    ${EXTERNAL_LOGIN_FORM_SCOPE} .client-hub-login-wrapper {
      font-size: 13px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .input-form {
      gap: 16px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} input.cf-input {
      height: 38px;
      padding: 9px 10px;
      font-size: 13px;
      line-height: 18px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .input-title {
      margin-bottom: 4px;
      font-size: 11px;
      line-height: 14px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .remember-me-wrapper {
      margin: 18px 0 0;
      font-size: 13px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .remember-me-checkbox {
      position: static;
      display: inline-flex;
      align-items: flex-start;
      gap: 8px;
      max-width: 100%;
      min-width: 0;
      padding-left: 0;
      white-space: normal;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .checkmark {
      position: relative;
      top: 0;
      margin-right: 0;
      right: 0;
      flex: 0 0 18px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .input-icon {
      min-height: 38px;
      padding: 0 8px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .log-in {
      min-height: 38px;
      margin-top: 20px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .account-actions {
      margin-top: 16px;
    }

    ${EXTERNAL_LOGIN_FORM_SCOPE} .login-links,
    ${EXTERNAL_LOGIN_FORM_SCOPE} .login-links a {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      white-space: normal;
    }
  }
`;
